import { getStage, Stage } from "./urls";

const pricingIds = {
  production: {
    one: {
      yearly: "price_1LkvvPGDPHffw1V4WNhzJ3zC",
      monthly: "price_1LkvvPGDPHffw1V48h29vPRW",
    },
    two: {
      yearly: "price_1LkvvPGDPHffw1V4O4ywbZDW",
      monthly: "price_1LkvvPGDPHffw1V4eOdeNuaU",
    },
    three: {
      yearly: "price_1LkvvPGDPHffw1V4bKArwTGW",
      monthly: "price_1LkvvPGDPHffw1V4WybA3K1y",
    },
  },
  staging: {
    one: {
      yearly: "price_1KsXq1GDPHffw1V4lbH1M6mE",
      monthly: "price_1KsXq1GDPHffw1V4hT3f43Fb",
    },
    two: {
      yearly: "price_1KsXq2GDPHffw1V4hhTQ3KNg",
      monthly: "price_1KsXq2GDPHffw1V41Rulx7O7",
    },
    three: {
      yearly: "price_1KsXq2GDPHffw1V46CzjZ73S",
      monthly: "price_1KsXq2GDPHffw1V4z9o4U4SR",
    },
  },
};

export function getPricingPlans() {
  if (typeof process.env.DOPPLER_STAGE !== "undefined") {
    switch (process.env.DOPPLER_STAGE) {
      case "dev":
        return pricingIds.staging;
      case "stg":
        return pricingIds.staging;
      case "prd":
        return pricingIds.production;
      default:
        return pricingIds.staging;
    }
  }

  switch (getStage()) {
    case Stage.DEV:
      return pricingIds.staging;
    case Stage.STG:
      return pricingIds.staging;
    case Stage.PRD:
      return pricingIds.staging;
    case Stage.DEPLOY_DEV:
      return pricingIds.staging;
    case Stage.DEPLOY_STG:
      return pricingIds.staging;
    case Stage.DEPLOY_PRD:
      return pricingIds.production;
    default:
      return pricingIds.staging;
  }
}
